import { gettingCurrencyNumberWithOutSymbol } from "../../helpers/get-currency-number";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../store";
import { useEffect } from "react";
import moment from "moment";
import { setCalenderDate } from "../../reducers/reports_slice";
import TableView from "../../components/table_new";

const TradeOverviewReport = () => {
  const { tradeOverviewData, isLoading } = useSelector(
    (state: TRootState) => ({
      tradeOverviewData: state.reports.tradeOverviewData,
      isLoading: state.reports.isLoading,
    })
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setCalenderDate({
        fromDate: moment().startOf("month").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
        mode: "MONTHLY",
      })
    );
  }, []);

  return (
    <>
      <div className="card_space_18">

        <TableView
          height="calc(100vh - 14rem)"
          loading={isLoading}
          columns={[
            {
              key: "sNo",
              header: "#",
              className: "text-center min-w-[80px]",
            },
            {
              key: "closedTradeCount",
              header: "Closed Trades",
              className: "min-w-[150px]",
            },
            {
              key: "traderCount",
              header: "Traders",
              className: "min-w-[120px]",
            },
            {
              key: "gmv",
              header: "GMV (₹)",
              className: "min-w-[150px]",
              type: "NUMBER",
            },
            {
              key: "marketCount",
              header: "Trade Mandis",
              className: "min-w-[150px]",
            },
            {
              key: "activeTraders",
              header: "Active Traders",
              className: "min-w-[150px]",
            },
            {
              key: "cropCount",
              header: "Products",
              className: "min-w-[120px]",
            },
            {
              key: "tradeValue",
              header: "Moved Trade Value (₹)",
              className: "min-w-[180px]",
              type: "NUMBER",
            },
          ]}
          data={tradeOverviewData?.map((item, i) => {
            return {
              sNo: i + 1,
              closedTradeCount: item.closedTradeCount,
              traderCount: item.traderCount,
              gmv: gettingCurrencyNumberWithOutSymbol(item.gmv, true),
              marketCount: item.marketCount,
              activeTraders: item.activeTraders,
              cropCount: item.cropCount,
              tradeValue: gettingCurrencyNumberWithOutSymbol(item.tradeValue, true),
            };
          })}
        // rowClickAction="expand"
        // isRowExpandable={(row) => true}
        // renderExpandedRow={(row) => <span>hii</span> }
        />

      </div>
    </>
  );
};

export default TradeOverviewReport;
